<template>
<div class="comic-switcher row">
  <div class="three columns">
    <button
      class="button u-full-width"
      v-bind:disabled="!canGoBack()"
      @click="first"
    >&laquo;</button>
  </div>
  <div class="three columns">
    <button
      class="button u-full-width"
      v-bind:disabled="!canGoBack()"
      @click="prev"
    >&lsaquo;</button>
  </div>
  <div class="three columns">
    <button
      class="button u-full-width"
      @click="next"
      v-bind:disabled="!canGoForward()"
    >&rsaquo;</button>
  </div>
  <div class="three columns">
    <button
      class="button u-full-width"
      @click="last"
      v-bind:disabled="!canGoForward()"
    >&raquo;</button>
  </div>
</div>

</template>

<script>
export default {
  computed: {
    comicId () {
      return this.$store.comicId
    }
  },
  methods: {
    canGoBack () {
      return this.$store.state.comicId > 1
    },
    canGoForward () {
      return this.$store.state.comicId < this.$store.state.maxComicId
    },
    first () {
      this.$router.push({
        path: '/1'
      })
    },
    prev () {
      if (this.canGoBack()) {
        this.$router.push({
          path: '/' + (this.$store.state.comicId - 1)
        })
      }
    },
    next () {
      if (this.canGoForward()) {
        this.$router.push({
          path: '/' + (this.$store.state.comicId + 1)
        })
      }
    },
    last () {
      this.$router.push({
        path: '/' + (this.$store.state.maxComicId)
      })
    }
  }
}
</script>

<style scoped>
.button {
  font-size: 2rem;
}

.button:disabled,
.button:disabled:hover {
  background-color: #ccc;
  color: #888;
  border-color: #888;
}

@media (max-width: 550px) {
  .three.columns {
    width: 22%;
    margin-left: 4%;
  }

  .three.columns:first-child {
    margin-left: 0;
  }

  .three.columns .button {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// ComicNav.vue?2d652cb1